import { CHARACTERS_LIMIT_SMS_MESSAGE, URL_PLACEHOLDER } from '../../../Config/env';

export default function SMSCutter(text, prefixLength, subject, organizationName, groupName, hasImage) {
  const subjectText = subject ? subject + '-' : '';
  const isShortMode = ((text.length + prefixLength + subjectText.length) > CHARACTERS_LIMIT_SMS_MESSAGE) || hasImage;
  return isShortMode
    ? `${subjectText}Tap to view: ${URL_PLACEHOLDER}`
    : `${subjectText}${text}`.replace(/\n{2,}/g, '\n'); // remove extra line breaks;
}
